// extracted by mini-css-extract-plugin
export var active = "_hl-7";
export var blink = "_hl-8";
export var dropDownSelector = "_hl-4";
export var dropDownWrapper = "_hl-3";
export var fakeCursor = "_hl-6";
export var fontSizeButton = "_hl-9";
export var formQuillEditor = "_hl-0";
export var pressed = "_hl-a";
export var qlBlank = "_hl-1";
export var textFormattingToolbar = "_hl-2";
export var textToolbarOption = "_hl-5";